import React, { useEffect, useState, useRef, useImperativeHandle, forwardRef } from 'react';
import Table from './partials/TableOfficeStock';
import TableSummary from './partials/TableOfficeStockSummary';
import Api from '../../../_helpers/Api';
import Pagination from '../../Pagination';
import { useHistory, useLocation } from 'react-router-dom';

//modals
import AddOrEdit from './partials/AddOrEdit';
import Question from '../../modals/messages/Question';
import Filter from './partials/Filter';
import History from './partials/History';
import Transfer from './partials/Transfer';

import Skeleton from 'react-loading-skeleton';
import { trans } from '../../../_providers/Translation'
import TableReturned from './partials/TableReturned';

let timeout;

function OfficeStock(props, ref) {

    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const modalAddOrEditRef = useRef(null);
    const modalQuestionRef = useRef(null);
    const modalTransferRef = useRef(null);
    const modalHistoryRef = useRef(null);

    const [parts, setParts] = useState({
        loading: true,
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {
            stock: 'office',
            instock: '1',
        },
        setFilter: false,
        update: false,
    });

    useImperativeHandle(ref, () => ({
        add: () => {
            handleAdd();
        }
    }));


    useEffect(() => {
        setParts(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: {
                ...prev.filter,
                category_id: searchParams.get('category_id') || '',
                name: searchParams.get('name') || '',
                number: searchParams.get('number') || '',
                supplier_id: searchParams.get('supplier_id') || '',
                storage_id: searchParams.get('storage_id') || '',
                box: searchParams.get('box') || '',
                summary: searchParams.get('summary') || 1,
            },
            update: new Date().getTime()
        }))
    }, [location.search])

    useEffect(() => {
        if (parts.setFilter) {
            searchParams.set('page', parts.page);

            Object.entries(parts.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1]);
                // }
            });

            history.push('?' + searchParams.toString());
        }

    }, [parts.setFilter]);

    useEffect(() => {
        if (parts.update) {
            loadParts();
        }
    }, [parts.update])

    const loadParts = () => {

        let url = 'storage/stock-parts?page=' + parts.page;

        Object.entries(parts.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1];
        });

        setParts(prev => ({
            ...prev,
            loading: true
        }));

        Api.get(url)
            .then(res => {
                setParts(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    total: res.data.total,
                    pages: res.data.pages
                }));
            }).catch(err => {
                setParts(prev => ({
                    ...prev,
                    loading: false
                }));
            });
    }

    // create
    const handleAdd = () => {
        modalAddOrEditRef.current.add('office');
    }

    const handleCreate = part => {
        handleRefresh();
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id);
    }

    const handleUpdate = part => {
        handleReload();
    }

    // delete
    const handleDelete = id => {

        let modal = modalQuestionRef.current;

        modal.open(id);
        modal.onSuccess(() => {
            handleDestroy(id);
        });

    }

    const handleDestroy = id => {
        Api.post('storage/remove-part', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleRefresh();
            }
        });
    }

    const handleRefresh = () => {
        setParts(prev => ({
            ...prev,
            page: 1,
            update: new Date().getTime()
        }));
    }

    const handleReload = () => {
        setParts(prev => ({
            ...prev,
            update: new Date().getTime()
        }));
    }


    // Search
    const handleSearch = (key, val, delay = 300) => {
        clearTimeout(timeout);

        setParts(prev => ({
            ...prev,
            loading: true,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }));

        timeout = setTimeout(() => {
            setParts(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }));
        }, delay);
    }

    const handlePage = page => {
        setParts(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }));
    }

    const handleTransfer = id => {
        modalTransferRef.current.show(id);
    }

    const handleAcceptTransfer = id => {
        Api.post('storage/accept-transfer', {
            id: id
        }).then(res => {
            if (res.data) {

                let data = parts.data.map(i => {
                    if (i.id == id) {
                        i = res.data;
                    }
                    return i;
                });

                setParts(prev => ({
                    ...prev,
                    data: data
                }));
            }
        })
    }

    const handleHistory = id => {
        modalHistoryRef.current.show(id);

        // history.replace('?subject_id=' + id + '&subject_type=' + 'App\\Storage');
    }

    return (
        <>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Transfer
                ref={modalTransferRef}
                handleRefresh={handleRefresh}
            />

            <History
                ref={modalHistoryRef}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />

            <Filter
                filter={parts.filter}
                showSummary={true}
                handleSearch={handleSearch}
            />

            <div className="pannel">

                <TableReturned
                    onAccept={() => {
                        handleReload();
                    }}
                />

                <h3>
                    {trans('headings.storageParts')}
                </h3>

                {parts.loading
                    ?
                    <Skeleton height={45} count={10} />
                    :
                    <>
                        {Number(parts.filter.summary) === 1
                            ?
                            <TableSummary
                                parts={parts.data}
                                filter={parts.filter}
                            />
                            :
                            <Table
                                parts={parts.data}
                                filter={parts.filter}
                                handleEdit={handleEdit}
                                handleDelete={handleDelete}
                                handleTransfer={handleTransfer}
                                handleAcceptTransfer={handleAcceptTransfer}
                                handleHistory={handleHistory}
                                handleReload={handleReload}
                            />
                        }

                        <Pagination
                            pages={parts.pages}
                            page={parts.page}
                            handlePage={handlePage}
                        />
                    </>
                }
            </div>

        </>
    )
}

export default forwardRef(OfficeStock);